<template>
  <div>
    <page-header title="Edit Group" breadcrumb="Dashboard > Users and Groups > Add User" />
    <div class="card">
      <div class="container-fluid">
        <div class="row"> 
          <div class="col-md-4 col-lg-4 col-12">
            <div class="picture-upload-form text-center">
              <div class="my-3">
                <image-uploader
                  @input="handleImageUpload($event)"
                  @remove-image="removeImage"
                  :isUploadingImage="isUploadingImage"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="my-2">
          <p class="text-primary-yellow text-lg">Group Details</p>
        </div>
        <div class="input-row">
          <div class="new-user-form__single-input-wrapper">
            <label for="name" class="label">Group Name</label>
            <input type="text" class="input" v-model="newGroup.name" placeholder="-- Enter Group Name --" />
          </div>
          <div class="new-user-form__single-input-wrapper">
            <label for="group_description" class="label">Group Description</label>
            <input type="text" class="input" v-model="newGroup.description" placeholder="-- Enter Group Description --" />
          </div>
        </div>
        <div class="input-row">
          <div class="new-user-form__single-input-wrapper">
            <label for="group_type" class="label">Group Type</label>
            <!-- <input type="text" class="input" v-model="newGroup.type" placeholder="-- Enter Group Type --" /> -->
            <el-select v-model="newGroup.type">
              <el-option
                v-for="type in groupTypes"
                :key="type"
                :label="type"
                :value="type"
              >
              </el-option>
            </el-select>
          </div>
          <div class="new-user-form__single-input-wrapper">
            <label for="email" class="label">Group Email</label>
              <input
                type="text"
                class="input"
                id="email"
                v-model="newGroup.email"
              />
          </div>
        </div>
     
        <hr/>
        <group-members 
          @select-user="saveUser($event)"
          @remove-user="removeUser($event)"
          :refreshGroups="refreshGroups"
          ref="groupMembersForm" />
      </div>
    </div>
    <hr class="mx-4"/>
    <div class="flex items-center justify-between">
      <div class="cursor-pointer" @click="$router.go(-1)">
        <p>Cancel</p>
      </div>
      <primary-button buttonText="Save" :disabled="isButtonDisabled" @click="updateGroup" :loading="isCreatingGroup"/>
    </div>
  </div>
</template>

<script>
import GroupMembers from "@/components/3pl/Users/GroupMembers";
import ImageUploader from "@/components/3pl/Users/ImageUploader";
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components: {
    PageHeader,
    ImageUploader,
    GroupMembers
  },
  data() {
    return {
      newGroup: {
        name: "",
        description: "",
        type: "",
        email: "",
        groupUsers: [],
        superAdminId: ""
      },
      isUploadingImage: false,
      isCreatingGroup: false,
      groupTypes: ["functional", "management", "Project"],
      designations: [{}],
      refreshGroups: false,
       payload: {
        description: "",
        email: "latest@gmail.com",
        groupUsers: [
                // {
                //     "userId": "928af0df-5a26-416b-8d8c-1cde10ab3647",
                //     "isAdmin": "false"
                // }
            ],
        name: "latest",
        orgId: "b8dbee24-2c80-4cb2-8db6-6cca1e6f91c0",
        superAdminId: "671b8045-d34e-49d6-9822-577054052592",
        type: "management"
          }
    };
  },
  computed: {
    isButtonDisabled() {
      // return this.shouldDisableButton(this.newGroup);
      return false
    },
  },
  mounted(){
    const group = JSON.parse(localStorage.getItem("editedGroup"));
    if (group) {
      this.newGroup = group;
    }
    this.getDesignations();
  },
  methods: {
    async getAdmins() {
      try {
        let response = await this.$_getAllUsers();
        this.users = response.data;
      } catch (error) {
        console.log(error);
        this.handleError(error);
      }
    },
    async updateGroup() {
      this.isCreatingGroup = true;
      try {
        await this.$_updateGroup(this.newGroup);
        this.onGroupCreated();
      } catch (error) {
        this.handleError(error);
        console.log(error);
        this.isCreatingGroup = false;
      }
    },
    async getAllUsers() {
      try {
        let response = await this.$_getAllUsers();
        console.log(response);
        this.loading = false;
        this.users = response.data
        localStorage.setItem("users", JSON.stringify(this.users));
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    onGroupCreated() {
      this.$store.dispatch("resetAllGroups");
      this.generateToast("Group has been successfully created!", "success");
      this.$router.push({ name: "UsersAndGroups" });
    },
    saveUser(users) {
      console.log(users,"selected u")
      this.newGroup.groupUsers.push(users);
    },
    removeUser(userId) {
      let filteredUsers = this.newGroup.groupUsers.filter((user) => {
        return user.userId != userId;
      });
      console.log(userId, filteredUsers, "remove file=ter")
      this.newGroup.groupUsers = filteredUsers;
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.newUser.imageurl = response;
        // console.log("imageurl", response);
        this.isUploadingImage = false;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.newUser.imageurl = null;
    },
    async getDesignations() {
      try {
        let response = await this.$_getAllDesignations();
        console.log(response);
        let designations = response.data.designations;
        this.designations = [{ name: "Nil", id: null }];
        this.designations = this.designations.concat(designations);
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
.picture-upload-form {
  /* border: 1px solid #edf2ef; */
  border-radius: 10px;
  padding: 1.55rem 1rem;
}
.picture-upload-form__img-wrapper {
  position: relative;
}
.user-img {
  width: 10rem;
  margin: 1.5rem auto;
} 
.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}
.picture-upload-form__meta {
  padding-top: 1rem;
}
.label {
  font-size: 0.9rem;
}
.input {
  margin-bottom: 0.5rem;
}
.new-user-form__col-three {
  padding-top: 1.25rem;
}
hr {
  /* width: 60%; */
  margin: 2rem auto;
}
.input-row {
  width: 100%;
  display: flex;
}
.input-row > div {
  width: 100%;
  padding-right: 1rem;
}
@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }
  .input-row div {
    width: 100%;
  }
}
</style>
